<script>
  import { onMount } from 'svelte'
  import { fetchReviews } from '../api.js'
  import Rating from '../components/Rating.svelte'
  import configMod from '../config.js'
  import { isMobileBrowser, getFontFamily } from '../utils.js'
  import FontLoader from '../components/FontLoader.svelte'
  import log from '../loader/log.js'
  import fontsMod from '../fonts.js'

  export let productId
  export let settingsResponse
  export let reviewsResponse
  export let isCollectionPage

  let averageRating = 0
  let totalCount = 0
  let starColor, reviewText, visibility, fontType
  let starWidget, starWidgetStyles, starFontSize
  let starRatingStyle = ''

  const fonts = fontsMod()
  const config = configMod()

  const scrollToProductWidget = () => {
    const productWidget = document.querySelector(
      `#${config.productWidgetDocumentId}`
    )

    if (productWidget) {
      const isSmoothScrollSupported =
        'scrollBehavior' in document.documentElement.style

      if (isSmoothScrollSupported) {
        const scrollToOptions = {
          top: productWidget.offsetTop,
          behavior: 'smooth'
        }

        window.scroll(scrollToOptions)
      } else {
        window.scroll(null, productWidget.offsetTop)
      }
    }
  }

  $: if (starWidget && isCollectionPage) {
    const productDetailsPlaceholderWidth = starWidget.parentElement.clientWidth
    const position = window
      .getComputedStyle(starWidget.parentElement)
      .getPropertyValue('text-align')
    if (productDetailsPlaceholderWidth >= 164) {
      starWidgetStyles = `justify-content: ${position}`
    }
    if (
      productDetailsPlaceholderWidth > 0 &&
      productDetailsPlaceholderWidth < 164
    ) {
      starWidgetStyles = `text-align: ${position}; display: block;`
      starFontSize = '150%'
    }
    if (window.matchMedia('(max-width: 440px)').matches) {
      starRatingStyle = 'max-width: none; margin-right: 0;'
    }
  }

  onMount(async () => {
    try {
      const isPreview = config.isPreview
      const isMobile = isMobileBrowser()

      const businessId = config.aid
      const clientId = config.apiKey

      const { data } = settingsResponse
      starColor = data.widget_settings.general_settings.star_rating_color
      reviewText = data.translations.reviews_text

      const desktopVisibility =
        !isMobile && data.widget_settings.star_rating.desktop_visibility
      const mobileVisibility =
        isMobile && data.widget_settings.star_rating.mobile_visibility

      visibility = desktopVisibility || mobileVisibility

      fontType = data.widget_settings.general_settings.font_type

      if ((productId || isPreview) && visibility) {
        let productParam = productId && { externalUniqueId: productId }

        productParam = !productId && isPreview ? {} : productParam

        const {
          metadata: { average, count }
        } =
          reviewsResponse ||
          (await fetchReviews({
            businessId,
            clientId,
            limit: 1,
            ...productParam
          }))

        averageRating = average
        totalCount = count
      }
    } catch (error) {
      log().error(error)
    } finally {
      config.isPreview &&
        window.dispatchEvent(new Event(config.previewLoadedEvent))
    }
  })
</script>

<style>
  :global([data-kb-widget-type='kb-star-widget'], .k_product_rating) {
    display: inline-block;
  }

  :global(.UBta8,)
  :global(.UBta8) * {
    font-family: var(--fontFamily);
  }
  :global(.UBta8) {
    display: inline-flex;
    cursor: pointer;
    align-items: center;
  }

  :global(.qXrDN) {
    margin-right: 0.5rem;
  }

  @media only screen and (max-width: 440px) {
    :global(.UBta8) {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    :global(.qXrDN) {
      max-width: max-content;
    }
  }
</style>

{#if averageRating}
  <FontLoader {fontType} />
  <div
    bind:this={starWidget}
    data-hook="kb-star-rating__widget"
    class="UBta8"
    on:click={scrollToProductWidget}
    style="{fonts[fontType] ? `--fontFamily: ${getFontFamily(fonts[fontType])};` : ''}{starWidgetStyles}">
    <div class="qXrDN" style={starRatingStyle}>
      <Rating
        reviewrating={averageRating}
        {starColor}
        fontSize={starFontSize} />
    </div>
    <div class="" style={`color: ${starColor}`}>
      {totalCount} {reviewText}
    </div>
  </div>
{/if}
